<template>
  <Layout>
    <PageHeader class="mc-page-three" :title="title">
      <template #afterTitle>
        <McButton
          variant="secondary"
          icon="icon-outline_arrow-left"
          :text="$t('global.back')"
          @click="$router.push({ name: 'Notification Setting' })"
        />
      </template>
    </PageHeader>
    <PageHeader
      v-if="false"
      class="mc-page-three"
      hasBackButton
      hasBreadcrumb
      :title="title"
      :routeBack="'/notification/setting'"
      :pageType="'transaction'"
    />

    <div class="mc-form mt-3">
      <div class="clearfix mb-3">
        <div class="float-start">
          <h4 class="card-title">
            {{ $t('notification.setting.emailNotification.basicInfo') }}
          </h4>
        </div>
        <div class="float-end">
          <b-button
            variant="outline-primary"
            class="mx-2"
            :disabled="hasChanged || !isEdit"
            @click="toCancel"
          >
            <i class="mc-fa icon-fill_close"></i> {{ $t('global.cancel') }}
          </b-button>
          <b-button
            variant="primary"
            :disabled="isSubmitting || hasChanged || !isEdit"
            @click="toSave"
          >
            <i class="mc-fa icon-outline_save"></i> {{ $t('global.save') }}
          </b-button>
        </div>
      </div>

      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <b-card>
            <b-skeleton width="25%" />
            <b-col md="4" class="my-3">
              <b-skeleton width="100%" height="40px" />
            </b-col>
          </b-card>

          <h4 class="card-title my-3">
            {{ $t('notification.setting.emailNotification.recipientList') }}
          </h4>
          <b-card>
            <b-skeleton width="100%" height="300px" />
          </b-card>

          <h4 class="card-title my-3">
            {{ $t('notification.setting.emailNotification.listFleetGroup') }}
          </h4>
          <b-card>
            <b-skeleton width="100%" height="350px" />
          </b-card>

          <h4 class="card-title my-3">
            {{ $t('notification.setting.emailNotification.setNotification') }}
          </h4>
          <b-card>
            <b-skeleton width="35%" height="30px" class="my-2" />
            <b-skeleton width="65%" height="300px" class="my-2" />
            <b-skeleton width="50%" height="30px" class="my-2" />
            <b-skeleton width="65%" height="30px" class="my-2" />
            <b-skeleton width="65%" height="30px" class="my-2" />
          </b-card>
        </template>
        <b-card>
          <FormulateForm v-model="form" refs="formRef">
            <b-row v-if="false" class="mb-3">
              <b-col md="4">
                <div class="d-flex flex-row my-2">
                  <McRadioButton
                    id="internal"
                    v-model="form.notificationType"
                    :name="'notificationType'"
                    :label="'Kirim ke internal'"
                    class="me-3"
                    :initialValue="'Internal'"
                    @change="setParameter('Internal')"
                  />
                  <McRadioButton
                    id="customer"
                    v-model="form.notificationType"
                    :name="'notificationType'"
                    :label="'Kirim ke pelanggan'"
                    :initialValue="'Customer'"
                    @change="setParameter('Customer')"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="3">
                <FormulateInput
                  validation-behavior="blur"
                  error-behavior="blur"
                  validation="required"
                  name="groupName"
                  :placeholder="$t('notification.setting.emailNotification.groupNotifName')"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('notification.setting.emailNotification.groupNotifName') }}
                        <i class="text-danger">*</i>
                      </label>
                    </div>
                  </template>
                </FormulateInput>
              </b-col>
              <b-col cols="3">
                <FormulateInput
                  v-if="form.notificationType === 'Customer'"
                  v-model="form.customerName"
                  validation-behavior="live"
                  error-behavior="live"
                  name="customerName"
                  :placeholder="$t('notification.setting.emailNotification.customerName')"
                  type="select-resourceful-v2"
                  :optionsGetter="resourcefulQuery.customer"
                  :optionLabelFn="({ item }) => item.customer"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('notification.setting.emailNotification.customerName') }}
                        <i class="text-danger">*</i>
                      </label>
                    </div>
                  </template>
                </FormulateInput>
              </b-col>
            </b-row>
          </FormulateForm>
        </b-card>

        <Recipient :isAdding="isAdding" :ngroupId="Number($route.params.id)" />

        <FleetGroupTable
          v-if="form.notificationType === 'Internal'"
          :isAdding="isAdding"
          :ngroupId="Number($route.params.id)"
        />

        <Notification :isAdding="isAdding" :ngroupId="Number($route.params.id)" :item="oldData" />
      </b-skeleton-wrapper>
    </div>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import FleetGroupTable from '../components/FleetGroupTable.vue'
import McRadioButton from '@/components/McRadioButton'
import Recipient from '../components/RecipientList.vue'
import Notification from '../components/NotificationList.vue'
import {
  GET_NOTIFICATION_GROUP,
  CREATE_NOTIFICATION_GROUP,
  UPDATE_NOTIFICATION_GROUP,
} from '@/services/api/notification/ngroup'
import McButton from '@/components/McButton'

export default {
  page: {
    title: 'Form',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    McButton,
    PageHeader,
    FleetGroupTable,
    McRadioButton,
    Recipient,
    Notification,
  },
  mixins: [Helper],
  data() {
    return {
      id: parseInt(this.$route.params.id),
      form: {
        groupName: '',
        notificationType: 'Internal',
      },
      emailList: [],
      loading: false,
      isEdit: false,
      isSubmitting: false,
      oldData: {
        groupName: null,
        alertCode: null,
        geofence: null,
      },
      filter: null,
      filterOn: [],
      filteredItems: [],
      report: '',
      optionsGetter: [],
      // fullObject: {
      //   customer: null,
      // },
    }
  },

  computed: {
    title() {
      return this.isAdding
        ? this.$t('notification.setting.emailNotification.addNotificationRecipient')
        : this.$t('notification.setting.emailNotification.notificationGroup')
    },
    isAdding() {
      return typeof this.$route.params.id === 'undefined'
    },
    resourcefulQuery() {
      return {
        customer: () => {
          return {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: [
                {
                  id: 1,
                  customer: 'Budi',
                },
                {
                  id: 2,
                  customer: 'Jak',
                },
                {
                  id: 3,
                  customer: 'Oni',
                },
                {
                  id: 4,
                  customer: 'Hani',
                },
                {
                  id: 5,
                  customer: 'Mari',
                },
              ],
            },
          }
        },
      }
    },
    hasChanged() {
      if (this.oldData.groupName === this.form.groupName) return true
      else return false
    },
  },
  watch: {
    'form.groupName': function (val) {
      this.isEdit = val ? true : false
    },
  },
  async mounted() {
    if (!this.isAdding) {
      await this.getData()
    }
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$apollo.query({
        query: GET_NOTIFICATION_GROUP,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ngroupId: Number(this.$route.params.id),
          },
        },
      })

      this.form.groupName = res.data.ngroup.ngroup.name
      this.oldData = {
        groupName: res.data.ngroup.ngroup.name,
        alertCode: res.data.ngroup.ngroup.ngroup2AlertCode.map((item) => item.alertCode),
        geofence: res.data.ngroup.ngroup.ngroup2Geofence,
      }
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    async toSave() {
      if (this.isSubmitting) {
        this.$mcToast.warning(this.$t('global.alert.text.pleaseWait'))
        return
      }
      this.isSubmitting = true

      if (this.isAdding) {
        const res = await this.$apollo.mutate({
          mutation: CREATE_NOTIFICATION_GROUP,
          variables: {
            input: {
              name: this.form.groupName,
            },
          },
        })

        if (!res.data.createNgroup.isSuccessful) {
          this.isSubmitting = false
          return
        }
        this.$mcToast.success(this.$t('global.alert.text.added'))

        this.$router
          .push({
            name: 'Email Notification Detail',
            params: { id: res.data.createNgroup.createNgroup.ngroupId },
          })
          .then(() => {
            window.location.reload()
          })
        this.isSubmitting = false
      } else {
        const res = await this.$apollo.mutate({
          mutation: UPDATE_NOTIFICATION_GROUP,
          variables: {
            input: {
              name: this.form.groupName,
              ngroupId: this.$route.params.id,
            },
          },
        })

        if (!res.data.updateNgroup.isSuccessful) {
          this.isSubmitting = false
          return
        }

        this.isSubmitting = false
        this.$mcToast.success(this.$t('global.alert.text.changed'))
      }

      this.oldData.groupName = this.form.groupName
      this.isSubmitting = false
    },
    async toCancel() {
      this.form.groupName = this.oldData.groupName
    },
    setParameter(value) {
      this.form.notificationType = value
    },
  },
}
</script>
